import React, { useState } from "react";
import { Link } from "react-router-dom";
import ProgressBar from "react-bootstrap/ProgressBar";
import Calculator from "../../Common/Calculator";
import BuyModal from "../../Layout/Modal/BuyModal";

const Hero = () => {
  const options = [
    {
      label: "USDT",
      value: "USDT",
      image: "/images/usdt-removebg-preview.png",
    },
    { label: "BNB", value: "BNB", image: "/images/bnb-bnb-logo.png" },
    {
      label: "WETH",
      value: "WETH",
      image: "/images/ethereum-logo-EC6CDBA45B-seeklogo.com.png",
    },
  ];
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
  };

  const files = [
    { name: "ZEUSS_whitepaper", url: "/images/ZEUSS_whitepaper.pdf" },
  ];
  const downloadFiles = () => {
    files.forEach((file) => {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  return (
    <>
      <section className="Hero">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-6">
              <div className="hero-content">
                <div className="mb-3">
                  <img src="./images/tribe.png" />
                </div>
                <div class="text-animate">
                  <span>T</span>
                  <span>h</span>
                  <span>e</span>
                  <span>&nbsp;</span>
                  <span>N</span>
                  <span>e</span>
                  <span>x</span>
                  <span>t</span>
                  <span>&nbsp;</span>
                  <span>U</span>
                  <span>n</span>
                  <span>i</span>
                  <span>c</span>
                  <span>o</span>
                  <span>r</span>
                  <span>n</span>
                  <span>&nbsp;</span>
                  <span>🦄</span>
                </div>
                {/* <h1>Buy and Stake</h1> */}
                <h1>The world's first Ai & ML App</h1>
                <h1 className="blue">
                  1000% APY – Exclusive limited-time offer!
                </h1>
                {/* <h1 class="aurora-heading">
                  Ship <span class="aurora-text">beautiful</span>
                </h1> */}
                {/* <p>
                  The best projects become Unicorns, as they ALWAYS solve a
                  market problem. ZEUSS' Z Chat...first International app,
                  combining WhatsApp, TIKTOK , AMAZON & APPLE PAY functions
                  all-in-one!
                </p> */}
                <p>
                  We're building TRIBE (Codenamed Project Z Chat), the World's
                  FIRST Ai & ML app that incorporates chats, short vids,
                  shopping & mobile payment system! We'll be building a smarter,
                  more intuitive, and easier app. So smart, it's predictive,
                  detects fraud & automates repetitive tasks!
                  <br />
                  The emphasis for TRIBE's UI/UX will be on a simple yet
                  superior user experience that feels effortless, intuitive, and
                  tailored to individual needs. So, imagine an app that
                  seamlessly integrates artificial intelligence and machine
                  learning to simplify and enhance every aspect of a user’s
                  daily life—whether it’s managing tasks, making smarter
                  decisions, or staying connected.
                </p>
                <div className="btns">
                  <Link className="start" onClick={downloadFiles} to="">
                    Whitepaper
                  </Link>
                  <BuyModal />
                  {/* <Link className="explore" to="">
                    BUY WITH CRYPTO
                  </Link> */}
                </div>
              </div>
            </div>
            <div
              className="offset-lg-1 col-lg-5 col-md-12 col-sm-12"
              id="calculator"
            >
              <Calculator />
              {/* <div className="calculator">
                <div className="content">
                  <h2>$ZEUSS Pre-Sale</h2>
                  <div className="progress">
                    <span>10M/200M $ZEUSS</span>
                    <ProgressBar now={10} />
                  </div>
                  <div className="launch-price">
                    <h4>
                      Current PreSale Price = <span>$0.0084280</span>
                    </h4>
                  </div>
                  <form className="calculateform">
                    <div className="form-group">
                      <div className="form-heading">
                        <label>I want to spend</label>
                      </div>

                      <div className="form">
                        <div>
                          <input
                            maxLength={10}
                            type="text"
                            className="form-control"
                            placeholder="Limit 10 - 5000"
                          />
                        </div>
                        <div className="select">
                          <div className="dropdown">
                            <div
                              className="dropdown-header"
                              onClick={toggleDropdown}
                            >
                              {selectedOption && (
                                <div className="dropdown-selected">
                                  <img
                                    src={selectedOption.image}
                                    alt={selectedOption.label}
                                  />
                                  <span>{selectedOption.label}</span>
                                  <i
                                    className={`dropdown-icon ${
                                      isOpen ? "open" : ""
                                    }`}
                                  >
                                    <img
                                      src="/images/calculatedrop.png"
                                      alt=""
                                    />
                                  </i>
                                </div>
                              )}
                            </div>
                            {isOpen && (
                              <div className="dropdown-list">
                                {options.slice(0 || 1).map((option) => (
                                  <div
                                    key={option.label}
                                    className="dropdown-item"
                                    onClick={() => handleOptionClick(option)}
                                  >
                                    <img
                                      src={option.image}
                                      alt={option.label}
                                    />
                                    <span>{option.label}</span>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="form-heading">
                        <label>I will receive</label>
                        <label>1USDT = 118.65ZEUSS </label>
                      </div>
                      <div className="form">
                        <div>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="0"
                          />
                        </div>
                        <div className="select">
                          <img src="/images/zeusscircle.png" alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="calculate-btn">
                      <div className="row" style={{ minHeight: "auto" }}>
                        <div className="col-lg-6 col-sm-12">
                          <button type="button" className="btn form-control">
                            Buy with
                            <img src="./images/card.png" alt="" />
                          </button>
                        </div>
                        <div className="col-lg-6 col-sm-12">
                          <button type="button" className="btn form-control">
                            Buy with
                            <img src="./images/paypal.png" alt="" />
                          </button>
                        </div>
                      </div>
                      <button type="button" className="btn form-control">
                        Buy & Stake $ZEUSS
                      </button>
                      <button type="button" className="btn form-control">
                        Buy $ZEUSS
                      </button>
                    </div>
                  </form>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Hero;
